import { Typography, TypographyProps, useTheme } from '@mui/material';

const Kbd = ({ children, ...props }: TypographyProps) => {
    const theme = useTheme();
    return (
        <Typography
            component="kbd"
            color="text.primary"
            sx={{
                fontFamily: 'monospace',
                fontSize: 'calc(1em - 4px)', // Font size - border
                fontWeight: theme.typography.fontWeightBold,
                borderColor: 'var(--mui-palette-elevation-outline-variant)',
                borderStyle: 'solid',
                borderWidth: '1px 1px 3px',
                backgroundColor: 'var(--mui-palette-background-paper)',
                borderRadius: '0.35rem',
                px: 0.5,
                py: 0,
            }}
            {...props}
        >
            {children}
        </Typography>
    );
};

export default Kbd;
